module.exports = __webpack_public_path__ + "static/media/btl2_logo.329bc018.png";